/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable arrow-body-style */
import {
	Box,
	Container,
	Flex,
	Icon,
	Image,
	Text,
	VStack,
} from "@chakra-ui/react";
import { MdLocationOn, MdPhone } from "react-icons/md";

const GreenReturnsVenueLayout = () => {
	return (
		<Box width="100%" mb="100px">
			<Box bg="#197542" py="80px" w="100%">
				<Text
					fontWeight="700"
					fontSize={{ xs: "26px", md: "48px" }}
					lineHeight="130%"
					color="#fff"
					textAlign="center"
				>
					Venue
				</Text>
			</Box>
			<Container maxW="container.lg">
				<Box my="100px">
					<Flex direction={{ base: "column", md: "row" }} gap={5}>
						{/* Image of the hotel */}
						<Image
							src="https://static.levocdn.com/WGLBUT82/60a71e9f6c4258a5e527ee065af08c5c2ba76d1ca6c28dc38ac807490a30-ImvEBQTrvRFb.jpg"
							alt="Taj Palace Hotel, New Delhi"
							borderRadius="md"
							w={{ base: "100%", md: "600px" }}
							objectFit="cover"
						/>

						{/* Hotel information */}
						<VStack align="flex-start" spacing={3}>
							<Text fontSize="3xl" fontWeight="bold">
								Taj Palace Hotel, New Delhi
							</Text>

							<Flex align="center">
								<Icon
									as={MdLocationOn}
									boxSize={5}
									color="#197542"
									mt="-25px"
								/>
								<Text ml={2} fontSize="large">
									<strong>Address:</strong> Diplomatic Enclave, Sardar Patel
									Marg, New Delhi, Delhi 110021
								</Text>
							</Flex>

							<Flex align="center">
								<Icon as={MdPhone} boxSize={5} color="#197542" />
								<Text ml={2} fontSize="large">
									<strong>Phone:</strong> +91 11 2611 0202
								</Text>
							</Flex>
						</VStack>
					</Flex>

					{/* Google Map iframe */}
					<Box
						mt={5}
						border="1px solid"
						borderColor="gray.300"
						borderRadius="md"
						overflow="hidden"
					>
						<iframe
							title="map"
							src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14019.78096239934!2d77.1734017!3d28.5899289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1dc6a3cd2f47%3A0xc8f367e4c79c5b3d!2sTaj%20Palace%2C%20New%20Delhi!5e0!3m2!1sen!2sin!4v1696345982514!5m2!1sen!2sin"
							width="100%"
							height="400"
							style={{ border: 0 }}
							allowFullScreen
							loading="lazy"
							referrerPolicy="no-referrer-when-downgrade"
						/>
					</Box>
				</Box>
			</Container>
		</Box>
	);
};

export default GreenReturnsVenueLayout;
